import { spriteSheet } from 'engine/facets/SpriteFacet';

export const PlayerShadow = <rect width={83} height={18} rx={10} x={-47} y={-14} opacity={0.1} />;

export const PlayerSprite = spriteSheet({
  idle: {
    frames: [
      <><rect width="159" height="230" fill="none" /><path d="M112.61,104.5a152.5,152.5,0,0,0-.46,23.49c.73,13.32,8.35,29.51,8.35,29.51" transform="translate(-0.5 -0.5)" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M84.51,84.5H97.18a17.32,17.32,0,0,1,17.32,17.32v56.37A17.32,17.32,0,0,1,97.18,175.5H52.82A17.32,17.32,0,0,1,35.5,158.18V133.51A49,49,0,0,1,84.51,84.5Z" fill="#33302d" /><rect x="76.5" y="20.5" width="58" height="70" rx="18.28" fill="#fee4c8" /><path d="M86,23s-1.38,16.9-5,25.45-6,5-6,5L76.77,20Z" transform="translate(-0.5 -0.5)" fill="#603813" /><path d="M106.5,163.5s2,18,2,33-1,25-1,25" transform="translate(-0.5 -0.5)" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /><circle cx="81.5" cy="68.5" r="4" /><circle cx="128.5" cy="68.5" r="4" /><path d="M116.33,11H53.67A22.67,22.67,0,0,0,31,33.67v39.8A25.53,25.53,0,0,0,56.53,99h59.8A22.67,22.67,0,0,0,139,76.33V33.67A22.67,22.67,0,0,0,116.33,11ZM135,73.36A17.64,17.64,0,0,1,117.36,91H92.64A17.64,17.64,0,0,1,75,73.36V38.64A17.64,17.64,0,0,1,92.64,21h24.72A17.64,17.64,0,0,1,135,38.64Z" transform="translate(-0.5 -0.5)" fill="#ff8400" stroke="#dd7300" strokeWidth="4" /><path d="M82,26s7.62,11.9,27.78,20.45,33.22,5,33.22,5S143,26,123.39,19,82,26,82,26Z" transform="translate(-0.5 -0.5)" fill="#603813" /><path d="M53.5,104.5s-5,23-4,34,6,23,6,23" transform="translate(-0.5 -0.5)" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M43.5,161s1,16.5,1,33.5-2,27-2,27" transform="translate(-0.5 -0.5)" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /></>,
    ],
    fps: 0,
  },
  running: {
    frames: [
      <><rect width="159" height="230" fill="none" /><path d="M103.5,101.5s-20,12-19,23,19,19,19,19" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M91.42,79h5.93A17.64,17.64,0,0,1,115,96.64v55.72A17.64,17.64,0,0,1,97.36,170H50.64A17.64,17.64,0,0,1,33,152.36V137.42A58.42,58.42,0,0,1,91.42,79Z" fill="#33302d" /><rect x="86" y="15" width="54" height="70" rx="17.64" fill="#fee4c8" /><path d="M95,17s-1.38,16.9-5,25.45-6,5-6,5L85.77,14Z" fill="#603813" /><path d="M38.5,155s.5,34-2,39.5S10,198,10,198" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /><circle cx="93" cy="61" r="4" /><circle cx="134" cy="61" r="4" /><path d="M121.33,5H58.67A22.67,22.67,0,0,0,36,27.67v39.8A25.53,25.53,0,0,0,61.53,93h59.8A22.67,22.67,0,0,0,144,70.33V27.67A22.67,22.67,0,0,0,121.33,5ZM140,67.36A17.64,17.64,0,0,1,122.36,85H103.64A17.64,17.64,0,0,1,86,67.36V32.64A17.64,17.64,0,0,1,103.64,15h18.72A17.64,17.64,0,0,1,140,32.64Z" fill="#ff8400" stroke="#dd7300" strokeWidth="4" /><path d="M92,20s7,11.9,25.5,20.45,30.5,5,30.5,5S148,20,130,13,92,20,92,20Z" fill="#603813" /><path d="M53.5,98.5a15.52,15.52,0,0,0,5,16c8,7,29.5-5.3,29.5-5.3" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M108.5,163.5s11,13,16,23,9,28,9,28" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /></>,
      <><rect width="159" height="230" fill="none" /><path d="M109.5,104.5s-3,15-2,26,19,19,19,19" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M91.42,85h5.93A17.64,17.64,0,0,1,115,102.64v55.72A17.64,17.64,0,0,1,97.36,176H50.64A17.64,17.64,0,0,1,33,158.36V143.42A58.42,58.42,0,0,1,91.42,85Z" fill="#33302d" /><rect x="82" y="21" width="58" height="70" rx="18.28" fill="#fee4c8" /><path d="M91,23s-1.38,16.9-5,25.45-6,5-6,5L81.77,20Z" fill="#603813" /><path d="M38.5,161s23,22.5,23,32.5S45,204,45,204" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /><path d="M108.5,163.5a337.57,337.57,0,0,1,0,34c-1,16-6,24-6,24" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /><circle cx="87" cy="69" r="4" /><circle cx="134" cy="69" r="4" /><path d="M121.33,11H58.67A22.67,22.67,0,0,0,36,33.67v39.8A25.53,25.53,0,0,0,61.53,99h59.8A22.67,22.67,0,0,0,144,76.33V33.67A22.67,22.67,0,0,0,121.33,11ZM140,73.36A17.64,17.64,0,0,1,122.36,91H97.64A17.64,17.64,0,0,1,80,73.36V38.64A17.64,17.64,0,0,1,97.64,21h24.72A17.64,17.64,0,0,1,140,38.64Z" fill="#ff8400" stroke="#dd7300" strokeWidth="4" /><path d="M87,26s7.62,11.9,27.78,20.45,33.22,5,33.22,5S148,26,128.39,19,87,26,87,26Z" fill="#603813" /><path d="M53.5,104.5s-10,15-9,26,11,19,11,19" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /></>,
      <><rect width="159" height="230" fill="none" /><path d="M106.5,101.5s-7,7,1,15,37-7,37-7" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M91.42,79h5.93A17.64,17.64,0,0,1,115,96.64v55.72A17.64,17.64,0,0,1,97.36,170H50.64A17.64,17.64,0,0,1,33,152.36V137.42A58.42,58.42,0,0,1,91.42,79Z" fill="#33302d" /><rect x="58" y="15" width="82" height="70" rx="21.74" fill="#fee4c8" /><path d="M82,17s-1.38,16.9-5,25.45-6,5-6,5L72.77,14Z" fill="#603813" /><path d="M38.5,155s13,23.5,17,37.5,7,25,7,25" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /><circle cx="79" cy="61" r="4" /><circle cx="134" cy="61" r="4" /><path d="M121.33,5H58.67A22.67,22.67,0,0,0,36,27.67v39.8A25.53,25.53,0,0,0,61.53,93h59.8A22.67,22.67,0,0,0,144,70.33V27.67A22.67,22.67,0,0,0,121.33,5ZM140,67.36A17.64,17.64,0,0,1,122.36,85H89.64A17.64,17.64,0,0,1,72,67.36V32.64A17.64,17.64,0,0,1,89.64,15h32.72A17.64,17.64,0,0,1,140,32.64Z" fill="#ff8400" stroke="#dd7300" strokeWidth="4" /><path d="M78,20s8.75,11.9,31.87,20.45,38.13,5,38.13,5S148,20,125.5,13,78,20,78,20Z" fill="#603813" /><path d="M53.5,98.5s-18,1-25,9-8,20-8,20" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M108.5,163.5s3,13,1,25-26,8-26,8" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /></>,
      <><rect width="159" height="230" fill="none" /><path d="M109.5,104.5s-3,15-2,26,19,19,19,19" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /><path d="M91.42,85h5.93A17.64,17.64,0,0,1,115,102.64v55.72A17.64,17.64,0,0,1,97.36,176H50.64A17.64,17.64,0,0,1,33,158.36V143.42A58.42,58.42,0,0,1,91.42,85Z" fill="#33302d" /><rect x="82" y="21" width="58" height="70" rx="18.28" fill="#fee4c8" /><path d="M91,23s-1.38,16.9-5,25.45-6,5-6,5L81.77,20Z" fill="#603813" /><path d="M38.5,161a214.67,214.67,0,0,1-1,33.5,83.24,83.24,0,0,1-8,27" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /><path d="M108.5,163.5s10,15,6,27-29,7-29,7" fill="none" stroke="#33302d" strokeLinecap="round" strokeWidth="9" /><circle cx="87" cy="69" r="4" /><circle cx="134" cy="69" r="4" /><path d="M121.33,11H58.67A22.67,22.67,0,0,0,36,33.67v39.8A25.53,25.53,0,0,0,61.53,99h59.8A22.67,22.67,0,0,0,144,76.33V33.67A22.67,22.67,0,0,0,121.33,11ZM140,73.36A17.64,17.64,0,0,1,122.36,91H97.64A17.64,17.64,0,0,1,80,73.36V38.64A17.64,17.64,0,0,1,97.64,21h24.72A17.64,17.64,0,0,1,140,38.64Z" fill="#ff8400" stroke="#dd7300" strokeWidth="4" /><path d="M87,26s7.62,11.9,27.78,20.45,33.22,5,33.22,5S148,26,128.39,19,87,26,87,26Z" fill="#603813" /><path d="M53.5,104.5s-10,15-9,26,11,19,11,19" fill="none" stroke="#4d5b58" strokeLinecap="round" strokeWidth="9" /></>,
    ],
    fps: 9,
  },
  stunned: {
    frames: [
      <>
        <path
          fill="#4d5b58"
          d="M709.63 413.25a4.49 4.49 0 01-2.43-.71c-1.92-1.24-18.77-12.46-18-25.74.72-11.54 6-26 6.2-26.65a4.5 4.5 0 118.45 3.08c0 .14-5 13.9-5.67 24.13-.42 6.81 10.12 15.2 13.84 17.61a4.5 4.5 0 01-2.44 8.28z"
          transform="translate(-622.32 -285.05)"
        />
        <path
          fill="#33302d"
          d="M727.1 458.81a87.26 87.26 0 00-14.1-26.32c-2.6-3.37-5.39-6.66-8.12-9.69a17.55 17.55 0 001.29-9.49l-7.92-55.16a17.63 17.63 0 00-20-14.95l-5.88.84a58.41 58.41 0 00-49.53 66.13L625 425a17.61 17.61 0 0013 14.56 178.33 178.33 0 0111.68 15.55 79.66 79.66 0 0110.78 24.19 4.49 4.49 0 004.4 3.57 4.88 4.88 0 00.93-.09 4.5 4.5 0 003.48-5.33 87.35 87.35 0 00-12.07-27.29c-2.48-3.77-5.19-7.46-7.82-10.83l41.84-6a17.59 17.59 0 008-3.29c2.26 2.55 4.53 5.25 6.65 8a80.18 80.18 0 0112.55 23.32 4.48 4.48 0 004.32 3.26 4.55 4.55 0 001.25-.18 4.5 4.5 0 003.11-5.63z"
          transform="translate(-622.32 -285.05)"
        />
        <rect
          width="58"
          height="70"
          x="59.35"
          y="12"
          fill="#fee4c8"
          rx="18.28"
        />
        <path
          fill="#603813"
          d="M690.67 299.05s-1.38 16.91-5 25.45-6 5-6 5l1.76-33.45z"
          transform="translate(-622.32 -285.05)"
        />
        <path
          fill="#ff8400"
          d="M721 287.05h-62.66a22.67 22.67 0 00-22.67 22.67v39.8a25.52 25.52 0 0025.52 25.53H721a22.68 22.68 0 0022.68-22.67v-42.66A22.68 22.68 0 00721 287.05zm18.68 62.36A17.65 17.65 0 01722 367.05h-24.69a17.64 17.64 0 01-17.64-17.64v-34.72a17.64 17.64 0 0117.64-17.64H722a17.65 17.65 0 0117.65 17.64z"
          transform="translate(-622.32 -285.05)"
        />
        <path
          fill="#dd7300"
          d="M721 377.05h-59.8a27.55 27.55 0 01-27.52-27.53v-39.8a24.7 24.7 0 0124.67-24.67H721a24.7 24.7 0 0124.68 24.67v42.66A24.7 24.7 0 01721 377.05zm-62.65-88a20.7 20.7 0 00-20.67 20.67v39.8a23.55 23.55 0 0023.52 23.53H721a20.7 20.7 0 0020.68-20.67v-42.66A20.71 20.71 0 00721 289.05zm63.68 80h-24.72a19.66 19.66 0 01-19.64-19.64v-34.72a19.66 19.66 0 0119.64-19.64H722a19.67 19.67 0 0119.65 19.64v34.72A19.67 19.67 0 01722 369.05zm-24.71-70a15.66 15.66 0 00-15.64 15.64v34.72a15.65 15.65 0 0015.64 15.64H722a15.66 15.66 0 0015.65-15.64v-34.72A15.66 15.66 0 00722 299.05z"
          transform="translate(-622.32 -285.05)"
        />
        <path
          fill="#603813"
          d="M686.67 302.05s7.62 11.91 27.77 20.45 33.23 5 33.23 5 0-25.45-19.61-32.45-41.39 7-41.39 7z"
          transform="translate(-622.32 -285.05)"
        />
        <path
          fill="#4d5b58"
          d="M650.16 421.05a4.51 4.51 0 01-2.81-1c-.47-.38-11.51-9.35-12.67-22.11-.11-1.29-.83-13 9.74-28.9a4.5 4.5 0 017.49 5c-2.54 3.81-9 15.4-8.26 23.09.8 8.85 9.24 15.83 9.33 15.9a4.5 4.5 0 01-2.82 8z"
          transform="translate(-622.32 -285.05)"
        />
        <path
          d="M699.17 349.55a2.81 2.81 0 01-.65-.07l-9-2a3 3 0 011.3-5.86l9 2a3 3 0 01-.65 5.93zM728.17 349.55a3 3 0 01-1.19-5.76l7-3a3 3 0 012.37 5.52l-7 3a3.11 3.11 0 01-1.18.24z"
          transform="translate(-622.32 -285.05)"
        />
      </>,
    ],
    fps: 0,
  },
  working: {
    frames: [
      <>
        <path fill="none" d="M0 0H159V230H0z" />
        <path
          fill="none"
          stroke="#33302d"
          strokeLinecap="round"
          strokeWidth="9"
          d="M43 160.5s1 16.5 1 33.5-2 27-2 27M106 163s2 18 2 33-1 25-1 25"
        />
        <path
          fill="none"
          stroke="#4d5b58"
          strokeLinecap="round"
          strokeWidth="9"
          d="M107.69 104.71a152.15 152.15 0 0022.7-6c12.61-4.37 26.07-16.16 26.07-16.16"
        />
        <path
          fill="#33302d"
          d="M84.51 84.5h12.67a17.31 17.31 0 0117.32 17.32v56.37a17.33 17.33 0 01-17.32 17.31H52.82a17.31 17.31 0 01-17.32-17.32v-24.67a49 49 0 0149-49z"
        />
        <rect
          width="58"
          height="70"
          x="76.5"
          y="20.5"
          fill="#fee4c8"
          rx="18.28"
        />
        <path
          fill="#603813"
          d="M85.5 22.5s-1.38 16.9-5 25.5-6 5-6 5l1.77-33.5z"
        />
        <circle cx="81.5" cy="68.5" r="4" />
        <circle cx="128.5" cy="68.5" r="4" />
        <path
          fill="#ff8400"
          stroke="#dd7300"
          strokeWidth="4"
          d="M115.83 10.5H53.17A22.67 22.67 0 0030.5 33.17V73A25.53 25.53 0 0056 98.5h59.8a22.67 22.67 0 0022.7-22.67V33.17a22.67 22.67 0 00-22.67-22.67zm18.67 62.36a17.64 17.64 0 01-17.64 17.64H92.14A17.64 17.64 0 0174.5 72.86V38.14A17.64 17.64 0 0192.14 20.5h24.72a17.64 17.64 0 0117.64 17.64z"
        />
        <path
          fill="#603813"
          d="M81.5 25.5s7.62 11.9 27.78 20.5 33.22 5 33.22 5 0-25.45-19.61-32.45S81.5 25.5 81.5 25.5z"
        />
        <path
          fill="none"
          stroke="#4d5b58"
          strokeLinecap="round"
          strokeWidth="9"
          d="M52.87 107.53s15.36 17.84 24.75 23.66 22 9.05 22 9.05"
        />
      </>,
      <>
        <path fill="none" d="M0 0H159V230H0z" />
        <path
          fill="none"
          stroke="#33302d"
          strokeLinecap="round"
          strokeWidth="9"
          d="M106 163s2 18 2 33-1 25-1 25M43 160.5s1 16.5 1 33.5-2 27-2 27"
        />
        <path
          fill="none"
          stroke="#4d5b58"
          strokeLinecap="round"
          strokeWidth="9"
          d="M108.53 107.53a151.55 151.55 0 0019 13.85c11.33 7.05 29 10.09 29 10.09"
        />
        <path
          fill="#33302d"
          d="M84.51 84.5h12.67a17.31 17.31 0 0117.32 17.32v56.37a17.33 17.33 0 01-17.32 17.31H52.82a17.31 17.31 0 01-17.32-17.32v-24.67a49 49 0 0149-49z"
        />
        <rect
          width="58"
          height="70"
          x="76.5"
          y="20.5"
          fill="#fee4c8"
          rx="18.28"
        />
        <path
          fill="#603813"
          d="M85.5 22.5s-1.38 16.9-5 25.5-6 5-6 5l1.77-33.5z"
        />
        <circle cx="81.5" cy="68.5" r="4" />
        <circle cx="128.5" cy="68.5" r="4" />
        <path
          fill="#ff8400"
          stroke="#dd7300"
          strokeWidth="4"
          d="M115.83 10.5H53.17A22.67 22.67 0 0030.5 33.17V73A25.53 25.53 0 0056 98.5h59.8a22.67 22.67 0 0022.7-22.67V33.17a22.67 22.67 0 00-22.67-22.67zm18.67 62.36a17.64 17.64 0 01-17.64 17.64H92.14A17.64 17.64 0 0174.5 72.86V38.14A17.64 17.64 0 0192.14 20.5h24.72a17.64 17.64 0 0117.64 17.64z"
        />
        <path
          fill="#603813"
          d="M81.5 25.5s7.62 11.9 27.78 20.5 33.22 5 33.22 5 0-25.45-19.61-32.45S81.5 25.5 81.5 25.5z"
        />
        <path
          fill="none"
          stroke="#4d5b58"
          strokeLinecap="round"
          strokeWidth="9"
          d="M51.21 107.1s23.52.93 34.18-2S107 95.23 107 95.23"
        />
      </>,
    ],
    fps: 12,
  },
});
